import React, { Fragment, useState } from 'react';
import BaseModal from '../../general/BaseModal';
import { translate as t } from '../../../lib/I18n';
import SmartcardLoadingDetails from '../delivery/smartcard/SmartcardLoadingDetails';
import SmartcardAppIcons from '../delivery/smartcard/SmartcardAppIcons';
import PropTypes from 'prop-types';

function SmartOrderSummary({ location, brand, isInterop, hasFlexiFares }) {
    const [showAppModal, setShowAppModal] = useState(false);

    const toggleAppModal = () => setShowAppModal(!showAppModal);

    const renderModal = () => (<BaseModal
        titleText={t('booking.delivery.smartcard.modal.title')}
        className="modal--lg load-smartcard-modal"
        onClose={toggleAppModal}
        hideContinue
    >
        <SmartcardLoadingDetails />
    </BaseModal>);

    if (brand === 'Southeastern') {
        return (
            <React.Fragment>
                <div className="order-summary__load-smartcard-info">
                    <p>
                        {t('confirmation.loadTickets.app')}{' '}
                        <SmartcardAppIcons toggleAppModal={toggleAppModal} />
                    </p>
                    <p>
                        {t('confirmation.loadTickets.station', {
                            location,
                        })}
                    </p>
                </div>
                {showAppModal && renderModal()}
            </React.Fragment>
        );
    }

    // GTR only below

    if (!hasFlexiFares) {
        return <p>{t('confirmation.smartcardNormal', { location, brand })}</p>;
    }

    return (<div className="order-summary__load-smartcard-info">
        {isInterop && <p>{t('booking.delivery.loadingdate.downloadGTRPaymentConfirmation', { brand: t('app.owner.appName') })}</p>}
        <p>
            <span>
                <Fragment>
                    {t('booking.delivery.loadingdate.downloadGTR', { brand: t('app.owner.appName') })}
                    <div className="smartcard-app-and-help-icons">
                        <SmartcardAppIcons toggleAppModal={toggleAppModal} />
                        <button onClick={toggleAppModal}>
                            <i className="otrl otrl-info" />
                        </button>
                    </div>
                </Fragment>
            </span>
        </p>
        {isInterop && <p>{t('booking.delivery.loading.info.interop')}</p>}
        {!isInterop && <div>
            <p>{t('booking.delivery.loadingdate.orderInfoGTRPartOne', { location })}
            <img className="tap-smartcard-icon" src="/images/registration/register-smartcard.png" alt={t('account.register.smartcard.alt')} />
            {t('booking.delivery.loadingdate.orderInfoGTRPartTwo')}</p>
        </div>}
        <div>
            {!isInterop && <p>
                <strong>{t('booking.delivery.loading.important.gtr1')}</strong>{t('booking.delivery.loading.important.gtr2')}
            </p>}
            <p>
                <span>{t('booking.delivery.loading.info.gtr')}</span>
            </p>
        </div>
        <div>{showAppModal && renderModal()}</div>
    </div>);
}

SmartOrderSummary.propTypes = {
  location: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  isInterop: PropTypes.bool,
  hasFlexiFares: PropTypes.bool
};

export default SmartOrderSummary;



// WEBPACK FOOTER //
// ./src/components/checkout/orderSummary/SmartOrderSummary.js